import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { theme } from '../theme';
import { useResponsive } from '../hooks/useResponsive';
import { useNotification } from './Notification';
import { useCreateGroup } from '../hooks/useGroups';

const CreateGroupPage: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const { showNotification } = useNotification();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const { createGroup, creating } = useCreateGroup({
    onError: (msg) => showNotification(msg, 'error'),
    onSuccess: () => {
      showNotification('Grupo creado', 'success');
      navigate('/groups');
    },
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      showNotification('El nombre del grupo es obligatorio', 'warning');
      return;
    }
    const group = await createGroup(name, description || undefined);
    if (group) navigate('/groups');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: theme.colors.background,
        padding: isMobile ? '80px 16px 20px' : '20px 40px',
      }}
    >
      <AppHeader title="Crear grupo" showBackButton />

      <div
        style={{
          maxWidth: 480,
          margin: '0 auto',
          background: theme.colors.surface,
          borderRadius: 20,
          padding: 28,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          border: `1px solid ${theme.colors.border}`,
        }}
      >
        <h1
          style={{
            fontSize: 22,
            fontWeight: 'bold',
            color: theme.colors.text,
            margin: '0 0 24px 0',
            fontFamily: theme.fonts.heading,
          }}
        >
          Nuevo grupo
        </h1>

        <form onSubmit={handleSubmit}>
          <label
            htmlFor="create-group-name"
            style={{
              display: 'block',
              fontSize: 14,
              fontWeight: 600,
              color: theme.colors.text,
              marginBottom: 8,
            }}
          >
            Nombre del grupo *
          </label>
          <input
            id="create-group-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder="Ej: Los pibes del barrio"
            style={{
              width: '100%',
              padding: '12px 14px',
              fontSize: 16,
              border: `2px solid ${theme.colors.border}`,
              borderRadius: 12,
              background: theme.colors.background,
              color: theme.colors.text,
              marginBottom: 20,
              boxSizing: 'border-box',
            }}
          />

          <label
            htmlFor="create-group-description"
            style={{
              display: 'block',
              fontSize: 14,
              fontWeight: 600,
              color: theme.colors.text,
              marginBottom: 8,
            }}
          >
            Descripción (opcional)
          </label>
          <textarea
            id="create-group-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            placeholder="Qué es este grupo..."
            style={{
              width: '100%',
              padding: '12px 14px',
              fontSize: 16,
              border: `2px solid ${theme.colors.border}`,
              borderRadius: 12,
              background: theme.colors.background,
              color: theme.colors.text,
              marginBottom: 24,
              resize: 'vertical',
              boxSizing: 'border-box',
            }}
          />

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={() => navigate('/groups')}
              style={{
                padding: '12px 24px',
                background: 'transparent',
                color: theme.colors.textSecondary,
                border: `2px solid ${theme.colors.border}`,
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={creating || !name.trim()}
              style={{
                padding: '12px 24px',
                background: creating || !name.trim() ? theme.colors.textSecondary : theme.colors.primary,
                color: theme.colors.background,
                border: 'none',
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 600,
                cursor: creating || !name.trim() ? 'not-allowed' : 'pointer',
              }}
            >
              {creating ? 'Creando...' : 'Crear grupo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateGroupPage;
